import { FormField, FormService } from '../services/formService';
import { Validations, Validators } from '../services/validations';
import { BaseModel } from './baseModel';
import { MatFormFieldModule } from '@angular/material';

export class BasicDetailModel extends BaseModel {
  student_id: FormField;
  student_name: FormField;
  gender: FormField;
  dob: FormField;
  place_of_birth: FormField;
  nationality: FormField;
  reservation_category: FormField;
  religion: FormField;
  caste: FormField;
  sub_caste: FormField;
  govt_id: FormField;
  mother_tongue: FormField;
  unique_id: FormField;
  blood_group: FormField;
  admission_no: FormField;
  reg_no: FormField;
  degree_code: FormField;
  teacher_ward: FormField;
  siblings: FormField;
  constructor() {
    super();
    this.student_id = new FormField("", false);
    this.student_name = new FormField("", true, [Validations.EMPTY, [Validations.LENGTH, 1, 100]]);
    this.gender = new FormField("", false);
    this.govt_id = new FormField("", false, []);
    this.admission_no = new FormField("", true, [Validations.SPACES]);
    this.dob = new FormField("", true, [Validations.EMPTY, Validations.DATE]);
    this.place_of_birth = new FormField("", false, [[Validations.LENGTH, 1, 25]],this.isPlaceOfBirthRequired);
    this.nationality = new FormField("IN", false);
    this.religion = new FormField("Hindu", false);
    this.caste = new FormField("", true, [Validations.EMPTY, [Validations.LENGTH, 1, 25]]);
    this.sub_caste = new FormField("", false, []);
    this.reservation_category = new FormField("", true, [Validations.EMPTY, [Validations.LENGTH, 1, 20]]);
    this.mother_tongue = new FormField("Kannada", false, [[Validations.LENGTH, 1, 20]], this.isMotherTongueRequired);
    this.unique_id = new FormField("", false);
    this.blood_group = new FormField("", false);
    this.reg_no = new FormField("", false);
    this.degree_code = new FormField("", true);
    this.teacher_ward = new FormField(false, false);
    this.siblings = new FormField(false, false);
  }
  isPlaceOfBirthRequired(){
    return !(Validators.isEmpty(this.place_of_birth.value) && (this.place_of_birth.value != "NA" || this.place_of_birth.value != "N/A"))
  }
  isMotherTongueRequired(){
    return !(Validators.isEmpty(this.mother_tongue.value) && (this.mother_tongue.value != "NA" || this.mother_tongue.value != "N/A"))
  }
  isGovtIdRequired() {
    return !(Validators.isEmpty(this.govt_id.value) && (this.govt_id.value != "NA" || this.govt_id.value != "N/A"))
  }
}

export class HigherDegreeModel extends BaseModel {
  place_of_class: FormField;
  year_of_passing: FormField;
  previous_institute_address: FormField;
  total_marks: FormField;
  marks_scored: FormField;
  constructor() {
    super()
    this.place_of_class = new FormField("", true)
    this.previous_institute_address = new FormField("", true)
    this.total_marks = new FormField("", false,[Validations.NUMBER])
    this.marks_scored = new FormField("", false,[Validations.NUMBER])
    this.year_of_passing = new FormField("", true)
  }
}

export class ContactDetailsModel extends BaseModel {
  present_address: FormField;
  permanent_address: FormField;
  same_address: FormField;
  student_email: FormField;
  student_phone: FormField;
  constructor() {
    super();
    this.present_address = new FormField("", true, [Validations.EMPTY, [Validations.LENGTH, 1, 100]]);
    this.permanent_address = new FormField("", true, [Validations.EMPTY, [Validations.LENGTH, 1, 100]], this.isPermanentAddress);
    this.same_address = new FormField(false, true, [Validations.EMPTY]);
    this.student_email = new FormField("", false, [Validations.EMAIL, [Validations.LENGTH, 1, 254]], this.isEmailRequired);
    this.student_phone =  new FormField("", true , [Validations.EMPTY,Validations.NUMBER]);
  }
  isEmailRequired() {
    return !(Validators.isEmpty(this.student_email.value) && (this.student_email.value != "NA" || this.student_email.value != "N/A"));
  }
  isPermanentAddress() {
    return this.same_address.value
  }
}

export class ClassDetailsModel extends BaseModel {
  current_class: FormField;
  current_section: FormField;
  constructor() {
    super();
    this.current_class = new FormField("", true, [Validations.EMPTY]);
    this.current_section = new FormField("", false);
  }
}

export class SchoolingDetailsModel extends BaseModel {
  previous_school: FormField;
  previous_school_class: FormField;
  previous_school_medium: FormField;
  is_physically_challenged: FormField;
  is_rte_student: FormField;
  is_scst: FormField;
  admitted_class: FormField;
  admitted_year: FormField;
  physically_challenged_Proof: FormField;
  rte_proof: FormField;
  scst_proof: FormField;
  branch_code: FormField;
  department_id: FormField;
  academic_year: FormField;
  admission_type: FormField;
  admission_date: FormField;
  previous_school_board: FormField;
  second_language: FormField;
  no_of_attempts: FormField;
  previous_pu_reg_no: FormField;
  constructor() {
    super();
    this.previous_school = new FormField("", false, [[Validations.LENGTH, 1, 100]],this.isPreviousSchoolRequired);
    this.previous_school_class = new FormField("", false, []);
    this.previous_school_medium = new FormField("English", false, [[Validations.LENGTH, 1, 20]],this.isPreviousSchoolMediumRequired);
    this.is_physically_challenged = new FormField(false, true);
    this.is_rte_student = new FormField(false, true);
    this.is_scst = new FormField(false, true);
    this.academic_year = new FormField("", true, [Validations.EMPTY]);
    this.admitted_class = new FormField("", false);
    this.branch_code = new FormField("", true, [Validations.EMPTY]);
    this.department_id = new FormField("", true, [Validations.EMPTY]);
    this.admitted_year = new FormField("2017-2018", true, [Validations.EMPTY]);
    this.physically_challenged_Proof = new FormField("", false, this.physicallyChallengedProofRequired);
    this.rte_proof = new FormField("", false, this.rteProofRequired);
    this.scst_proof = new FormField("", false, this.scstProofRequired);
    this.admission_type = new FormField("", false, [Validations.EMPTY]);
    this.admission_date = new FormField("", true, [Validations.EMPTY]);
    this.previous_school_board = new FormField("", false);
    this.second_language = new FormField("", false);
    this.no_of_attempts = new FormField("", false,[],this.isNoOfAttemptsRequired);
    this.previous_pu_reg_no = new FormField("", false,[],this.isPreviousPuRegNoRequired);
  }
  scstProofRequired() {
    return this.is_scst.value;
  }
  rteProofRequired() {
    return this.is_rte_student.value;
  }
  physicallyChallengedProofRequired() {
    return this.is_physically_challenged.value;
  }
  isPreviousSchoolRequired(){
    return !(Validators.isEmpty(this.previous_school.value) && (this.previous_school.value != "NA" || this.previous_school.value != "N/A"))
  }
  isPreviousSchoolMediumRequired(){
    return !(Validators.isEmpty(this.previous_school_medium.value) && (this.previous_school_medium.value != "NA" || this.previous_school_medium.value != "N/A"))
  }
  isNoOfAttemptsRequired(){
    return !(Validators.isEmpty(this.no_of_attempts.value) && (this.no_of_attempts.value != "NA" || this.no_of_attempts.value != "N/A"))
  }
  isPreviousPuRegNoRequired(){
    return !(Validators.isEmpty(this.previous_pu_reg_no.value) && (this.previous_pu_reg_no.value != "NA" || this.previous_pu_reg_no.value != "N/A"))
  }
}

export class GuardianDetailsModel extends BaseModel {
  guardian_name: FormField;
  occupation: FormField;
  annual_income: FormField;
  qualification: FormField;
  relation: FormField;
  phone_number: FormField;
  email: FormField;
  unique_id: FormField;
  bank_account_no: FormField;
  IFSC: FormField;
  RC_card: FormField;
  online_no: FormField;
  income_no: FormField;
  constructor() {
    super();
    this.guardian_name = new FormField("", true, [Validations.EMPTY, [Validations.LENGTH, 1, 100]]);
    this.occupation = new FormField("", false);
    this.annual_income = new FormField("0", false, [Validations.DECIMAL [Validations.LENGTH, 1, 10]]);
    this.qualification = new FormField("", false);
    this.relation = new FormField("", true);
    this.phone_number = new FormField("", true,[Validations.EMPTY, [Validations.LENGTH, 1, 10]]);
    this.email = new FormField("", false, [[Validations.LENGTH, 1, 254]], this.isEmailRequired);
    this.unique_id = new FormField("", false, [Validations.LENGTH, 1, 16], this.isUniqueIdRequired)
    this.bank_account_no = new FormField("", false);
    this.IFSC = new FormField("", false);
    this.income_no = new FormField("", false);
    this.RC_card = new FormField("", false);
    this.online_no = new FormField("", false);
  }
  isEmailRequired() {
    return !(Validators.isEmpty(this.email.value) && (this.email.value != "NA" || this.email.value != "N/A"));
  }

  isUniqueIdRequired() {
    return !(Validators.isEmpty(this.unique_id.value) && (this.unique_id.value != "NA" || this.unique_id.value != "N/A"))
  }
}

export class StudentViewModel extends BaseModel {
  student_id: FormField;
  student_name: FormField;
  constructor() {
    super();
    this.student_id = new FormField("", false);
    this.student_name = new FormField("", false);
  }
}
// Admission Page FormFiield
export class AdmissionModel extends BaseModel {
  gender: FormField;
  branch_code: FormField;
  current_class: FormField;
  admission_date: FormField;
  admission_type: FormField;
  student_name: FormField;
  dob: FormField;
  previous_school_class: FormField;
  previous_school: FormField;
  previous_school_board: FormField;
  department_id: FormField
  academic_year: FormField
  present_address: FormField;
  addGuardians: FormField
  fatherDetails: FatherDetailsModel
  motherDetails: MotherDetailsModel
  gaurdiansDetails: GuardiansDetailsModel
  constructor() {
    super();
    this.gender = new FormField("M", true, [Validations.EMPTY]);
    this.fatherDetails = new FatherDetailsModel()
    this.motherDetails = new MotherDetailsModel()
    this.gaurdiansDetails = new GuardiansDetailsModel()
    this.branch_code = new FormField("", true, [Validations.EMPTY]);
    this.current_class = new FormField("", true, [Validations.EMPTY]);
    this.admission_date = new FormField("", true, [Validations.EMPTY]);
    this.admission_type = new FormField("", false);
    this.student_name = new FormField("", true, [Validations.EMPTY]);
    this.dob = new FormField("", true, [Validations.EMPTY]);
    this.previous_school_class = new FormField("", true, [Validations.EMPTY]);
    this.previous_school = new FormField("", true, [Validations.EMPTY]);
    this.previous_school_board = new FormField("", true, [Validations.EMPTY]);
    this.department_id = new FormField("", true, [Validations.EMPTY]);
    this.academic_year = new FormField("", true, [Validations.EMPTY])
    this.present_address = new FormField("", true, [Validations.EMPTY]);
    this.addGuardians = new FormField(false, true, [Validations.EMPTY], this.validates);
  }
  validates() {
    if (!this.addGuardians.value) {
      if (this.fatherDetails.guardian_name.isValid() && this.fatherDetails.qualification.isValid() && this.fatherDetails.phone_number.isValid() || this.motherDetails.guardian_name.isValid() && this.motherDetails.qualification.isValid() && this.motherDetails.phone_number.isValid()) {
        return (this.fatherDetails.validate_father_name() && this.motherDetails.validate_mother_name())
      } else {
        this.fatherDetails.validate()
        this.motherDetails.validate()
        return false
      }
    } else if (this.addGuardians.value) {
      return (this.gaurdiansDetails.validate() && this.fatherDetails.validate_father_name() && this.motherDetails.validate_mother_name())
    }
  }
}

export class FatherDetailsModel extends BaseModel {
  guardian_name: FormField
  qualification: FormField;
  phone_number: FormField;
  constructor() {
    super();
    this.guardian_name = new FormField("", true, [Validations.EMPTY]);
    this.qualification = new FormField("", false);
    this.phone_number = new FormField("", true, [Validations.EMPTY, Validations.NUMBER, [Validations.LENGTH, 1, 10]], this.validate_father_name);
  }
  validate_father_name() {
    if (this.phone_number.value != undefined && this.phone_number.value != "") {
      if (this.phone_number.validate()) {
        if (this.guardian_name.isValid()) {
          return true
        } else if (!this.guardian_name.isValid()) {
          return this.guardian_name.validate()
        }
      } else {
        return false
      }
    } else {
      return true
    }
  }
}

export class MotherDetailsModel extends BaseModel {
  guardian_name: FormField;
  qualification: FormField;
  phone_number: FormField;
  constructor() {
    super();
    this.guardian_name = new FormField("", true, [Validations.EMPTY]);
    this.qualification = new FormField("", false);
    this.phone_number = new FormField("", true, [Validations.EMPTY, Validations.NUMBER, [Validations.LENGTH, 1, 10]], this.validate_mother_name);
  }
  validate_mother_name() {
    if (this.phone_number.value != undefined && this.phone_number.value != "") {
      if (this.phone_number.validate()) {
        if (this.guardian_name.isValid()) {
          return true
        } else if (!this.guardian_name.isValid()) {
          return this.guardian_name.validate()
        }
      } else {
        return false
      }
    } else {
      return true
    }
  }
}

export class GuardiansDetailsModel extends BaseModel {
  guardian_name: FormField;
  qualification: FormField;
  phone_number: FormField;
  constructor() {
    super();
    this.guardian_name = new FormField("", true, [Validations.EMPTY]);
    this.qualification = new FormField("", false);
    this.phone_number = new FormField("", true, [Validations.EMPTY, Validations.NUMBER, [Validations.LENGTH, 10, 10]]);
  }
}

export class SiliconAdmissionModel extends BaseModel {
  gender: FormField;
  branch_code: FormField;
  current_class: FormField;
  admission_date: FormField;
  admission_type: FormField;
  student_name: FormField;
  dob: FormField;
  previous_school_class: FormField;
  previous_school: FormField;
  previous_school_board: FormField;
  department_id: FormField
  academic_year: FormField
  present_address: FormField;
  addGuardians: FormField
  fatherDetails: FatherDetailsModel
  motherDetails: MotherDetailsModel
  gaurdiansDetails: GuardiansDetailsModel
  student_email: FormField;
  student_phone: FormField;
  degree_code: FormField;
  constructor() {
    super();
    this.gender = new FormField("", false);
    this.fatherDetails = new FatherDetailsModel()
    this.motherDetails = new MotherDetailsModel()
    this.gaurdiansDetails = new GuardiansDetailsModel()
    this.branch_code = new FormField("", true, [Validations.EMPTY]);
    this.current_class = new FormField("", false);
    this.admission_date = new FormField("", false);
    this.admission_type = new FormField("", false);
    this.student_name = new FormField("", true, [Validations.EMPTY]);
    this.dob = new FormField("", false);
    this.previous_school_class = new FormField("", false);
    this.previous_school = new FormField("", false);
    this.previous_school_board = new FormField("", false);
    this.department_id = new FormField("", true, [Validations.EMPTY]);
    this.academic_year = new FormField("", false, [Validations.EMPTY])
    this.present_address = new FormField("", false);
    this.addGuardians = new FormField(false, true, [Validations.EMPTY], this.validates);
    this.student_phone = new FormField("", true, [Validations.EMPTY,Validations.NUMBER,[Validations.LENGTH, 10,10]]);
    this.student_email = new FormField("", false, [Validations.EMAIL, [Validations.LENGTH, 1, 254]], this.isEmailRequired);
    this.degree_code = new FormField("", true);
  }
  isEmailRequired() {
    return !(Validators.isEmpty(this.student_email.value) && (this.student_email.value != "NA" || this.student_email.value != "N/A"));
  }
  validates() {
    if (!this.addGuardians.value) {
      if (this.fatherDetails.guardian_name.isValid() && this.fatherDetails.qualification.isValid() && this.fatherDetails.phone_number.isValid() || this.motherDetails.guardian_name.isValid() && this.motherDetails.qualification.isValid() && this.motherDetails.phone_number.isValid()) {
        return (this.fatherDetails.validate_father_name() && this.motherDetails.validate_mother_name())
      } else {
        this.fatherDetails.validate()
        this.motherDetails.validate()
        return false
      }
    } else if (this.addGuardians.value) {
      return (this.gaurdiansDetails.validate() && this.fatherDetails.validate_father_name() && this.motherDetails.validate_mother_name())
    }
  }
}
